import { UpdateProjectComponent } from "testly-web/queries";

export const UpdateProjectMutation = UpdateProjectComponent;
